export default "__VITE_ASSET__DIt9FJZs__"